<template>
  <div>
    <!-- <v-row style="margin-top: -75px;"> -->
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              v-bind="attrs"
              v-on="on"
            >
            Create Permission
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template> -->
          <v-card>
            <v-card-title>
              <span class="headline">Create New Permission</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="5">
                        <v-card-text><b>Generated Permission: </b></v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <v-card-text>{{ generatedPermission }}</v-card-text>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select
                    v-model="action"
                    :items="items"
                    label="Action"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field label="Name*" v-model="name" required hint="Make sure it's easy to remember" ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field label="Description*" v-model="description" required></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveNewPermission" :disabled="disableSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LoadingOverlay from "./common/LoadingOverlay.vue";

export default {
    name: 'PermissionModal',
    props: {
      dialog: Boolean
    },
    components: {
      LoadingOverlay
    },
    data() {
        return {
            errorMessage: "",
            disableSave: false,
            loading: false,
            name: '',
            description: '',
            generatedPermission: '',
            action: '',
            items: ['create', 'update', 'read', 'delete'],
        }
    },
    methods: {
        ...mapActions(["createPermission", "fetchPermissions"]),
        validate() {
          if(this.action == ""){
            this.errorMessage = "Action must not be empty"
            return
          }
          if(this.name == ""){
            this.errorMessage = "Name must not be empty"
            return
          }
          else{
            this.errorMessage = ""
            return
          }
          
        },
        async saveNewPermission() {
            this.validate();
            if(this.errorMessage == ""){
              this.disableSave = true;
              this.loading = true;
              const body = {
                  name: this.name,
                  description: this.description
              }
              await this.createPermission(body).then(() => {
                this.disableSave = false;
                this.loading = false
                this.errorMessage = ""
              });
              this.fetchPermissions();
              
              this.$emit("closeDialog", true)
            }
        },
        close() {
          this.$emit("closeDialog", false)
          this.errorMessage = "";
        }
    },
    computed: mapGetters["allPermissions"],
    watch: {
        action: function (val) {
            this.generatedPermission = val + ' ' + this.name + ' key';
        },
        name: function () {
            this.generatedPermission = this.action + ' ' + this.name + ' key';
        }
    }
}
</script>

<style>

</style>